<template>
  <div dir="ltr">
    <!-- Search Input -->
    <div class="search-container">
      <input
        v-model="searchQuery"
        type="text"
        placeholder="Search by ID, Company Name, or Title"
        class="input is-fullwidth mb-5"
      />
    </div>

    <div v-if="is_loading" dir="ltr">
      <div class="relative loading center_horizontal"></div>
    </div>

    <div v-else>
      <div v-for="related_resource in filteredData" :key="related_resource.id"
           class="is-flex is-align-items-center is-justify-content-flex-end full_width black_border_bottom_width_2px">
        <div class="text_align_left" style="width: 35%;">
          <a @click="openCVModal(related_resource)" class="button is-info">CV</a>
          <div class="vertical_space"></div>
          <offer-status v-if="related_resource.offer" :payload="related_resource.offer"></offer-status>
          <div class="vertical_space"></div>
          <p v-if="related_resource.offer"><b>DISTANCE: </b>{{ related_resource.offer.distance }}</p>
        </div>
        <div class="horizontal_space"></div>
        <div class="horizontal_space"></div>
        <div class="horizontal_space"></div>
        <RelatedResource :related_resource="related_resource" />
      </div>
      <p v-if="filteredData.length === 0" class="text_align_center" dir="ltr">NO RELATED POSITIONS.</p>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import RelatedResource from '@/components/RelatedResource'
import OfferStatus from '@/components/OfferStatus'

export default {
  name: 'related-positions',
  components: {
    RelatedResource,
    OfferStatus
  },
  props: ['payload'],
  data () {
    return {
      is_loading: false,
      relatedPositions: [],
      data: [],
      searchQuery: ''
    }
  },
  computed: {
    ...mapGetters('offerStatuses', ['getGreenList']),
    filteredData () {
      if (!this.searchQuery.trim()) {
        return this.data
      }

      const query = this.searchQuery.trim().toLowerCase()

      if (/^\d+$/.test(query)) { // If only numbers, search by position ID
        return this.data.filter(item => item.leader.position.id.toString() === query)
      } else { // Otherwise, search by title or company name
        return this.data.filter(item =>
          item.leader.position.title.toLowerCase().includes(query) ||
          item.leader.position.company.name.toLowerCase().includes(query)
        )
      }
    }
  },
  created () {
    this.is_loading = true
    this.$network_utils.getPositions({
      similar_positions: this.payload.position.id,
      is_hot: 'true'
    }).then(response => {
      this.relatedPositions = response
      this.getOffers()
    })
  },
  methods: {
    openCVModal (relatedResource) {
      // If there's an existing offer, use it; otherwise create a temporary offer object
      const offerData = relatedResource.offer || {
        position: relatedResource.leader.position,
        applicant: this.payload.applicant,
        // Add any other required fields for the CV modal
        id: null,
        status: null
      }

      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data: offerData,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },
    getOffers () {
      this.relatedPositions.forEach(position => {
        this.$network_utils.getOfferBy({ applicant_id: this.payload.applicant.resource_id, position_id: position.id }).then(response => {
          // Always add the position to data array, regardless of offer status
          // This ensures CV buttons are always visible
          this.data.push({
            offer: response.length > 0 ? response[0] : null,
            leader: { position }
          })
          this.$forceUpdate()
        })
      })
      this.is_loading = false
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
